export default __webpack_public_path__ + "static/media/reply_icon.feb6b5f3.svg";